/** 菜单 router_name / route.name 与侧栏 resolveMenuLabel 使用的顶层 key 对齐 */
export default {
  deviceManage: '设备管理',
  taskManage: '任务管理',
  material_apply: '物料申请',
  robot_media_center: '媒体中心',
  enum_management: '枚举管理',
  product_config: '产品配置',
}
